export const translations = {
    en: {
        // Navigation
        home: "Home",
        about: "About",
        skills: "Skills",
        experience: "Experience",
        education: "Education",
        projects: "Projects",
        hackathons: "Hackathons",
        contact: "Contact",

        // Hero Section
        heroGreeting: "Hi, I'm",
        heroTitle: "AI Engineering Student passionate about creating impactful solutions.",
        heroDescription: "Building the future with cutting-edge technology, from intelligent gaming systems to enterprise platforms.",
        viewWork: "View Work",
        contactMe: "Contact Me",

        // About Section
        aboutTitle: "About Me",
        aboutSubtitle: "A blend of technical depth and passion for impact.",
        aboutText1: "I am a <strong class='text-white'>4th-year AI Engineering student</strong> at <strong class='text-white'>ESPRIT University</strong> (Tunisia). My journey is defined by a drive to build systems that matter. I bridge the gap between complex <strong class='text-white'>Artificial Intelligence</strong> algorithms and user-friendly <strong class='text-white'>Full-Stack</strong> applications.",
        aboutText2: "My technical expertise spans from training <strong class='text-white'>Deep Learning</strong> models with <strong class='text-white'>PyTorch</strong> to deploying scalable web apps using <strong class='text-white'>React</strong> and <strong class='text-white'>Django</strong>. I am particularly interested in <strong class='text-white'>NLP</strong>, <strong class='text-white'>Computer Vision</strong>, and <strong class='text-white'>AI Agents</strong>.",
        aboutText3: "When I'm not coding, you'll find me participating in <strong class='text-white'>hackathons</strong>, mentoring fellow students, or exploring the latest developments in <strong class='text-white'>AI</strong> and <strong class='text-white'>Machine Learning</strong>. I believe in the power of technology to solve complex problems and improve lives.",
        aboutQuote: "Building tomorrow's solutions with today's innovation.",        // Skills Section
        skillsTitle: "Technical Arsenal",
        skillsSubtitle: "The tools and technologies I use to bring ideas to life.",
        aiMlTitle: "AI & Machine Learning",
        webDevTitle: "Web Development",
        programmingLanguagesTitle: "Languages",
        infraTitle: "Infrastructure & Tools",

        // Experience Section
        experienceTitle: "Professional Experience",
        experienceSubtitle: "My journey through the tech industry.",
        current: "Current",

        // Education Section
        educationTitle: "Education",
        certificationsTitle: "Certifications",

        // Projects Section
        projectsTitle: "Featured Projects",
        projectsSubtitle: "Innovations in AI and Software Engineering.",
        winner: "Winner",
        viewProject: "View Project",

        // Contact Section
        contactTitle: "Ready to Collaborate?",
        contactDescription: "Whether you have a question, a project idea, or just want to say hi, I'll try my best to get back to you!",
        sendEmail: "Send an Email",
        linkedinProfile: "LinkedIn Profile",

        // Languages Section
        languagesTitle: "Languages",
        englishLevel: "English (TOEFL C1)",
        frenchLanguage: "French",
        arabicLanguage: "Arabic",
        fluentLevel: "Fluent",
        nativeLevel: "Native",

        // Footer
        footerText: "Built with React & Tailwind CSS.",

        // Hackathons Section
        viewAllPhotos: "View all {{count}} photos",
        hackathonMemory: "Hackathon memory",
        certificateNotSupported: "Certificate format not supported for preview",

        // Common
        readMore: "Read More",
        showLess: "Show Less",
        viewCertificate: "View Certificate",
        verify: "Verify",
        github: "GitHub",
        demo: "Live Demo",
        presentation: "Presentation",

        // Months
        jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr", may: "May", jun: "Jun",
        jul: "Jul", aug: "Aug", sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec"
    },

    fr: {
        // Navigation
        home: "Accueil",
        about: "À propos",
        skills: "Compétences",
        experience: "Expérience",
        education: "Formation",
        projects: "Projets",
        hackathons: "Hackathons",
        contact: "Contact",

        // Hero Section
        heroGreeting: "Salut, je suis",
        heroTitle: "Étudiant en ingénierie IA passionné par la création de solutions impactantes.",
        heroDescription: "Construire l'avenir avec des technologies de pointe, des systèmes de jeu intelligents aux plateformes d'entreprise.",
        viewWork: "Voir mes Travaux",
        contactMe: "Me Contacter",

        // About Section
        aboutTitle: "À Propos de Moi",
        aboutSubtitle: "Un mélange de profondeur technique et de passion pour l'impact.",
        aboutText1: "Je suis étudiant en <strong class='text-white'>4ème année d'ingénierie IA</strong> à l'<strong class='text-white'>Université ESPRIT</strong> (Tunisie). Mon parcours est défini par une volonté de construire des systèmes qui comptent. Je fais le pont entre les algorithmes complexes d'<strong class='text-white'>Intelligence Artificielle</strong> et les applications <strong class='text-white'>Full-Stack</strong> conviviales.",
        aboutText2: "Mon expertise technique s'étend de l'entraînement de modèles <strong class='text-white'>Deep Learning</strong> avec <strong class='text-white'>PyTorch</strong> au déploiement d'applications web évolutives utilisant <strong class='text-white'>React</strong> et <strong class='text-white'>Django</strong>. Je suis particulièrement intéressé par le <strong class='text-white'>NLP</strong>, <strong class='text-white'>Computer Vision</strong> et les <strong class='text-white'>AI Agents</strong>.",
        aboutText3: "Quand je ne code pas, vous me trouverez en train de participer à des <strong class='text-white'>hackathons</strong>, de mentorer d'autres étudiants, ou d'explorer les derniers développements en <strong class='text-white'>IA</strong> et <strong class='text-white'>Machine Learning</strong>. Je crois au pouvoir de la technologie pour résoudre des problèmes complexes et améliorer la vie.",
        aboutQuote: "Construire les solutions de demain avec l'innovation d'aujourd'hui.",        // Skills Section
        skillsTitle: "Arsenal Technique",
        skillsSubtitle: "Les outils et technologies que j'utilise pour donner vie aux idées.",
        aiMlTitle: "IA & Machine Learning",
        webDevTitle: "Développement Web",
        programmingLanguagesTitle: "Langages",
        infraTitle: "Infrastructure & Outils",

        // Experience Section
        experienceTitle: "Expérience Professionnelle",
        experienceSubtitle: "Mon parcours dans l'industrie technologique.",
        current: "Actuel",

        // Education Section
        educationTitle: "Formation",
        certificationsTitle: "Certifications",

        // Projects Section
        projectsTitle: "Projets Phares",
        projectsSubtitle: "Innovations en IA et Ingénierie Logicielle.",
        winner: "Gagnant",
        viewProject: "Voir le Projet",

        // Contact Section
        contactTitle: "Prêt à Collaborer ?",
        contactDescription: "Que vous ayez une question, une idée de projet, ou que vous vouliez simplement dire bonjour, je ferai de mon mieux pour vous répondre !",
        sendEmail: "Envoyer un Email",
        linkedinProfile: "Profil LinkedIn",

        // Languages Section
        languagesTitle: "Langues",
        englishLevel: "Anglais (TOEFL C1)",
        frenchLanguage: "Français",
        arabicLanguage: "Arabe",
        fluentLevel: "Courant",
        nativeLevel: "Natif",

        // Footer
        footerText: "Créé avec React & Tailwind CSS.",

        // Hackathons Section
        viewAllPhotos: "Voir toutes les {{count}} photos",
        hackathonMemory: "Souvenir de hackathon",
        certificateNotSupported: "Format de certificat non pris en charge pour l'aperçu",

        // Common
        readMore: "Lire Plus",
        showLess: "Voir Moins",
        viewCertificate: "Voir le Certificat",
        verify: "Vérifier",
        github: "GitHub",
        demo: "Démo Live",
        presentation: "Présentation",

        // Months
        jan: "Jan", feb: "Fév", mar: "Mar", apr: "Avr", may: "Mai", jun: "Juin",
        jul: "Juil", aug: "Août", sep: "Sep", oct: "Oct", nov: "Nov", dec: "Déc"
    },

    de: {
        // Navigation
        home: "Startseite",
        about: "Über mich",
        skills: "Fähigkeiten",
        experience: "Erfahrung",
        education: "Bildung",
        projects: "Projekte",
        hackathons: "Hackathons",
        contact: "Kontakt",

        // Hero Section
        heroGreeting: "Hallo, ich bin",
        heroTitle: "KI-Ingenieurstudent mit Leidenschaft für wirkungsvolle Lösungen.",
        heroDescription: "Die Zukunft mit modernster Technologie gestalten, von intelligenten Gaming-Systemen bis hin zu Unternehmensplattformen.",
        viewWork: "Arbeiten Ansehen",
        contactMe: "Kontaktieren",

        // About Section
        aboutTitle: "Über Mich",
        aboutSubtitle: "Eine Mischung aus technischer Tiefe und Leidenschaft für Wirkung.",
        aboutText1: "Ich bin Student im <strong class='text-white'>4. Jahr KI-Ingenieurwesen</strong> an der <strong class='text-white'>ESPRIT Universität</strong> (Tunesien). Meine Reise ist geprägt von dem Antrieb, Systeme zu bauen, die wichtig sind. Ich überbrücke die Kluft zwischen komplexen <strong class='text-white'>Künstliche Intelligenz</strong>-Algorithmen und benutzerfreundlichen <strong class='text-white'>Full-Stack</strong>-Anwendungen.",
        aboutText2: "Meine technische Expertise reicht vom Training von <strong class='text-white'>Deep Learning</strong>-Modellen mit <strong class='text-white'>PyTorch</strong> bis zur Bereitstellung skalierbarer Web-Apps mit <strong class='text-white'>React</strong> und <strong class='text-white'>Django</strong>. Ich interessiere mich besonders für <strong class='text-white'>NLP</strong>, <strong class='text-white'>Computer Vision</strong> und <strong class='text-white'>KI-Agenten</strong>.",
        aboutText3: "Wenn ich nicht gerade programmiere, finden Sie mich bei <strong class='text-white'>Hackathons</strong>, beim Mentoring anderer Studenten oder beim Erkunden der neuesten Entwicklungen in <strong class='text-white'>KI</strong> und <strong class='text-white'>Machine Learning</strong>. Ich glaube an die Kraft der Technologie, komplexe Probleme zu lösen und Leben zu verbessern.",
        aboutQuote: "Die Lösungen von morgen mit der Innovation von heute bauen.",        // Skills Section
        skillsTitle: "Technisches Arsenal",
        skillsSubtitle: "Die Tools und Technologien, die ich verwende, um Ideen zum Leben zu erwecken.",
        aiMlTitle: "KI & Machine Learning",
        webDevTitle: "Webentwicklung",
        programmingLanguagesTitle: "Sprachen",
        infraTitle: "Infrastruktur & Tools",

        // Experience Section
        experienceTitle: "Berufserfahrung",
        experienceSubtitle: "Meine Reise durch die Tech-Industrie.",
        current: "Aktuell",

        // Education Section
        educationTitle: "Bildung",
        certificationsTitle: "Zertifizierungen",

        // Projects Section
        projectsTitle: "Hauptprojekte",
        projectsSubtitle: "Innovationen in KI und Software Engineering.",
        winner: "Gewinner",
        viewProject: "Projekt Ansehen",

        // Contact Section
        contactTitle: "Bereit zur Zusammenarbeit?",
        contactDescription: "Ob Sie eine Frage haben, eine Projektidee oder einfach nur Hallo sagen möchten, ich werde mein Bestes geben, um Ihnen zu antworten!",
        sendEmail: "E-Mail Senden",
        linkedinProfile: "LinkedIn-Profil",

        // Languages Section
        languagesTitle: "Sprachen",
        englishLevel: "Englisch (TOEFL C1)",
        frenchLanguage: "Französisch",
        arabicLanguage: "Arabisch",
        fluentLevel: "Fließend",
        nativeLevel: "Muttersprache",

        // Footer
        footerText: "Erstellt mit React & Tailwind CSS.",

        // Hackathons Section
        viewAllPhotos: "Alle {{count}} Fotos ansehen",
        hackathonMemory: "Hackathon-Erinnerung",
        certificateNotSupported: "Zertifikatsformat wird für die Vorschau nicht unterstützt",

        // Common
        readMore: "Mehr Lesen",
        showLess: "Weniger Zeigen",
        viewCertificate: "Zertifikat Ansehen",
        verify: "Verifizieren",
        github: "GitHub",
        demo: "Live Demo",
        presentation: "Präsentation",

        // Months
        jan: "Jan", feb: "Feb", mar: "Mär", apr: "Apr", may: "Mai", jun: "Jun",
        jul: "Jul", aug: "Aug", sep: "Sep", oct: "Okt", nov: "Nov", dec: "Dez"
    }
};